import React from 'react';
import cn from 'classnames';
import BentoCard from './BentoCard';

import * as styles from './CardsGrid.module.scss';

export default function CardsGrid({ cards }) {
  const gridTemplateClassName = `gridTemplateFor${cards.length}Cards`;

  return (
    <div className={cn(styles.gridContainer, styles[gridTemplateClassName])}>
      {cards.map((card, index) => {
        const cardClassName = `card${index + 1}`;
        return <BentoCard key={card.title} className={styles[cardClassName]} {...card} />;
      })}
    </div>
  );
}
